const SPS_ID = "sps_id";
const LANDING = "landing";
const UPLOAD = "upload";
const SPS_PATH_PREFIX = "/api/v1/sps";

export { SPS_ID, LANDING, UPLOAD, SPS_PATH_PREFIX };
